
import { BaseComponent, notificationTypes } from 'project/general';
import { BaseForm } from 'shared/base-form';
import { baseApi } from 'project/api';
import { notificationService } from 'project/services';


class SimpleFormComponent extends BaseComponent {
    static getNamespace() {
        return 'simple-from';
    }

    onInit() {
        this.formInstance = new BaseForm(this.element, {
            submitElement: this.element.querySelector('button[type="submit"]'),
            errorsSummary: this.element.querySelector('[data-errors-summary]'),
            onSuccessfulSubmit: (response) => {
                SimpleFormComponent.onSuccessfulSubmit(response.data);
            },
            onFailedSubmit: (error) => {
                console.error(error);
            },
            parsley: {
                errorClass: 'is-invalid',
                successClass: 'is-valid',
                errorsWrapper: '<div class="field-validation-error" aria-live="assertive" aria-atomic="true"></div>',
                errorTemplate: '<div></div>',
            },
            axiosInstance: baseApi,
            ...this.options
        });
    }

    static onSuccessfulSubmit(data) { // only for ajax requests
        if (data.success && data.redirectUrl) {
            window.location.href = data.redirectUrl;
        } else if (data.success && data.message) {
            notificationService.push({
                message: data.message,
                type: notificationTypes.SUCCESS,
            });
        }
    }

    onDestroy() {
        this.formInstance.destroy();
    }
}

export default SimpleFormComponent;
